﻿import { Directive, Input, Output, EventEmitter, ElementRef, HostListener, OnInit, AfterViewInit, Renderer, OnDestroy } from '@angular/core';

@Directive({
    selector: '[enclosed]'
})
export class EnclosedDirective {


    @HostListener('click', ['$event']) keyupInput(event: MouseEvent) {
       event.stopPropagation();
       event.stopImmediatePropagation();
    }

}